import AvatarSignUp from "./SignupAvatar";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useLogin } from "../../context/LoginProvider";

export default function ProtectedSignup() {
  const { isLoggedIn, userData, guestData } = useLogin();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  
  useEffect(() => {
    // Add a small delay to ensure guest data has been loaded from localStorage
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 200);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (isLoading) return; // Don't redirect while loading

    // Check if user is editing interests
    const isEditingInterests = localStorage.getItem("editingInterests") === "true";

    console.log("[ProtectedSignup] Current state:", {
      isLoggedIn,
      userData: userData.interests?.length || 0,
      guestData: {
        username: guestData.username,
        name: guestData.name,
        age: guestData.age,
        country: guestData.country,
        interests: guestData.interests?.length || 0,
        isFreshGuest: guestData.isFreshGuest
      },
      isEditingInterests
    });

    // If user is editing interests, clear the flag and show cupid page
    if (isEditingInterests) {
      localStorage.removeItem("editingInterests");
      console.log("[ProtectedSignup] User is editing interests - showing cupid page");
      return; // Stay on cupid page
    }

    // For registered users: If user has interests, go to profile summary
    if (isLoggedIn && userData.interests.length !== 0) {
      console.log("[ProtectedSignup] Redirecting to profile summary - registered user has interests");
      navigate("/profile-summary", { replace: true });
      return;
    }

    // For guest users: Only redirect to profile summary if they have interests AND are not a fresh guest
    if (!isLoggedIn && guestData.interests.length !== 0 && !guestData.isFreshGuest) {
      console.log("[ProtectedSignup] Redirecting to profile summary - guest has interests and is not fresh");
      navigate("/profile-summary", { replace: true });
      return;
    }

    // If guest user hasn't filled their info, redirect to guest info form
    if (!isLoggedIn && guestData.username && (!guestData.name || !guestData.age || !guestData.country)) {
      console.log("[ProtectedSignup] Redirecting to guest-info - missing guest info");
      navigate("/guest-info", { replace: true });
      return;
    }

    // If we reach here, show the cupid page
    console.log("[ProtectedSignup] Showing cupid page");
  }, [isLoggedIn, userData, guestData, navigate, isLoading]);

  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px',
        color: '#6616cd'
      }}>
        Loading...
      </div>
    );
  }

  return (
    <>
      <AvatarSignUp />
    </>
  );
}
